/**
 * Remove all external event listeners.
 */
export default function() {
  var listeners = this._eventListeners,
      n = listeners.length, m, e;

  while (--n >= 0) {
    e = listeners[n];
    m = e.sources.length;
    while (--m >= 0) {
      e.sources[m].removeEventListener(e.type, e.handler);
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-view/src/finalize.js
// module id = null
// module chunks = 